import React from 'react';

// Reusable MSP-code multi-select for the rule Scope section (v1.110.0). Mirrors the
// native-<select> + chip pattern used for tenant scope: options are the MSP catalog
// (from useAuth().user.mspCatalog = [{code, displayName}]) filtered to those not already
// selected; chips carry a remove button; everything is disabled/read-only in PROD.
//
// Codes are stored uppercase; the label shows "displayName (CODE)". The backend validates
// each code against MSP_CATALOG (fail-closed include — an unknown code silences the rule),
// so the picklist is the primary guard against typos.
export default function MspScopeSelect({ label, help, selected, setSelected, catalog, isProd, tone = 'sky' }) {
  const options = Array.isArray(catalog) ? catalog : [];
  const labelFor = (code) => {
    const m = options.find((o) => (o.code || '').toUpperCase() === code);
    return m ? `${m.displayName || m.code} (${code})` : code;
  };
  const chipCls = tone === 'amber'
    ? 'bg-amber-900/30 text-amber-300 border-amber-700/40'
    : 'bg-sky-900/30 text-sky-300 border-sky-700/40';
  const xCls = tone === 'amber'
    ? 'text-amber-400 hover:text-amber-200'
    : 'text-sky-400 hover:text-sky-200';

  return (
    <div>
      <label className="block text-sm font-medium text-gray-300 mb-1">{label}</label>
      {help && <p className="text-xs text-gray-500 mb-2">{help}</p>}
      {selected.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-2">
          {selected.map((code) => (
            <span key={code} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded border text-xs ${chipCls}`}>
              <span>{labelFor(code)}</span>
              <button
                type="button"
                onClick={() => !isProd && setSelected(selected.filter((x) => x !== code))}
                disabled={isProd}
                className={`${xCls} ${isProd ? 'opacity-50 cursor-not-allowed' : ''}`}
              >
                ×
              </button>
            </span>
          ))}
        </div>
      )}
      <select
        value=""
        disabled={isProd}
        onChange={(e) => {
          const code = e.target.value;
          if (code && !selected.includes(code)) setSelected([...selected, code]);
        }}
        className={`input-field w-full ${isProd ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        <option value="">— add MSP —</option>
        {[...options]
          .map((o) => ({ code: (o.code || '').toUpperCase(), displayName: o.displayName || o.code }))
          .filter((o) => o.code && !selected.includes(o.code))
          .sort((a, b) => (a.displayName || '').localeCompare(b.displayName || ''))
          .map((o) => (
            <option key={o.code} value={o.code}>
              {o.displayName} ({o.code})
            </option>
          ))}
      </select>
    </div>
  );
}
